module.exports = __webpack_public_path__ + "static/media/robertGloriaWedding47.4b7c50b3.png";